import styled from 'styled-components';
import { Grid, Label, Tooltip, DatePicker } from '@inplayer-org/inplayer-ui';
import FieldError from 'components/Fields/FieldError';

// styled components
import { BlueTypography } from 'components/SharedStyledElements';

const { Cell } = Grid;

export const StyledTypography = styled(BlueTypography)`
  margin-bottom: 1rem;
`;

export const StyledLabel = styled(Label)`
  margin-bottom: 5px;
`;

export const FieldWrapper = styled.div<{ customMargin?: string }>`
  display: flex;
  flex-direction: column;
  margin-top: ${({ customMargin }) => customMargin || '1rem'};
`;

export const StyledCell = styled(Cell)<{ marginTop?: boolean }>`
  margin-top: ${({ marginTop }) => (marginTop ? '1.25rem' : '0')};
  margin-left: 0.5rem;
`;

export const DateCell = styled(Cell)`
  display: flex;
  flex-direction: column;
`;

export const TooltipStyled = styled(Tooltip)`
  margin-left: 0.5rem;
`;

export const StyledDatePicker = styled(DatePicker)`
  .DateRangePicker.DateRangePicker_1 {
    width: 100% !important;
  }
  .DateRangePickerInput.DateRangePickerInput_1.DateRangePickerInput__withBorder.DateRangePickerInput__withBorder_2 {
    width: 100% !important;
    height: 38px !important;
  }
  .DateRangePicker_picker.DateRangePicker_picker_1.DateRangePicker_picker__directionLeft.DateRangePicker_picker__directionLeft_2 {
    left: -140px !important;
  }
`;

export const StyledFieldError = styled(FieldError)`
  font-size: ${({ theme }) => theme.font.sizes.small};
`;

export const ErrorWrapper = styled.div`
  height: 1rem;
`;

export const TooltipCell = styled(Cell)`
  display: flex;
  align-items: center;
`;

export const RadioButtonsWrapper = styled.div`
  margin-top: 0.5rem;
`;
